export default __webpack_public_path__ + "static/media/ud_my_request.6831f262.svg";